import React, { useState } from 'react';
import { TYPES } from '../../../../ui-components/typography/PlayText/PlayText';
import { contentoImageUrl } from '../../../../utils/svtimage';
import {
    Accessibility,
    AccessibilityText,
    AssociatedMoreInfoLink,
    AssociatedProgressBar,
    Content,
    ContentDescription,
    ContentHeader,
    ContentLink,
    ContentSubheader,
    ExpandButton,
    AssoiciatedContentImage,
    ImageContainer,
    ImageLink,
    Information,
    MobileDescription,
    UpcomingOverlay,
    UpcomingOverlayText,
} from './AssociatedContent.styles';
import { upcomingDates } from './util';
import OpenModal from '../../../VideoModal/OpenModal.tsx';
import { VisuallyHiddenStyle } from '../../../../ui-components/utils.styles';
import Link from 'next/link';

const AssociatedContentItem = ({ content, type, selectedVideoId, progress }) => {
    const imageSrc = contentoImageUrl(content.images.wide, 'large', 600);
    const isUpcoming = type === 'upcoming';
    const [expanded, setExpanded] = useState(false);
    const [shouldShowPlayIcon, setShouldShowPlayIcon] = useState(false);

    const accessibilities = content.item.accessibilities;

    const progressPercentage = progress ? progress[content.item.svtId] : null;
    const accessibleLabel = `Spela ${content.heading}`;

    return (
        <Content selected={content.item.videoSvtId === selectedVideoId}>
            <ImageContainer>
                {isUpcoming ? (
                    <>
                        <ImageLink as="div" shouldShowPlayIcon={false} isUpcoming aria-label="">
                            <AssoiciatedContentImage
                                src={imageSrc}
                                faded
                                blurred={content.item.restrictions.onlyAvailableInSweden}
                                onlyAvailableInSweden={content.item.restrictions.onlyAvailableInSweden}
                            />
                            <UpcomingOverlay
                                onlyAvailableInSweden={content.item.restrictions.onlyAvailableInSweden}
                                aria-hidden={true}
                            >
                                <UpcomingOverlayText bold>
                                    {upcomingDates(content.item.validFrom)[0]}
                                </UpcomingOverlayText>
                                <UpcomingOverlayText>
                                    {upcomingDates(content.item.validFrom)[1]}
                                </UpcomingOverlayText>
                            </UpcomingOverlay>
                        </ImageLink>
                    </>
                ) : (
                    <OpenModal videoId={content.item.videoSvtId} videoUrl={content.item.urls.svtplay}>
                        <ImageLink
                            onMouseEnter={() => {
                                setShouldShowPlayIcon(true);
                            }}
                            onMouseLeave={() => {
                                setShouldShowPlayIcon(false);
                            }}
                            shouldShowPlayIcon={shouldShowPlayIcon}
                            tabIndex={-1}
                            isUpcoming={false}
                            aria-label={accessibleLabel}
                        >
                            <AssoiciatedContentImage
                                src={imageSrc}
                                blurred={content.item.restrictions.onlyAvailableInSweden}
                                onlyAvailableInSweden={content.item.restrictions.onlyAvailableInSweden}
                            />
                            {progressPercentage ? (
                                <AssociatedProgressBar progress={progressPercentage} selected />
                            ) : null}
                        </ImageLink>
                    </OpenModal>
                )}
            </ImageContainer>
            <Information isUpcoming={isUpcoming}>
                <ContentHeader as="h3">
                    {isUpcoming ? (
                        <>
                            <span aria-hidden="true">{content.heading}</span>
                            <VisuallyHiddenStyle as="span">
                                {content.item.nameRaw
                                    ? `${content.item.positionInSeason}. ${content.item.nameRaw}`
                                    : content.heading}
                            </VisuallyHiddenStyle>
                        </>
                    ) : (
                        <OpenModal videoId={content.item.videoSvtId} videoUrl={content.item.urls.svtplay}>
                            <ContentLink
                                onMouseEnter={() => {
                                    setShouldShowPlayIcon(true);
                                }}
                                onMouseLeave={() => {
                                    setShouldShowPlayIcon(false);
                                }}
                                aria-label={accessibleLabel}
                            >
                                {content.heading}
                            </ContentLink>
                        </OpenModal>
                    )}
                </ContentHeader>
                <ContentSubheader type={TYPES.SMALL}>
                    <VisuallyHiddenStyle as="span">
                        {`${isUpcoming ? 'Publiceras' : 'Publicerades'}: ${content.item.validFromFormatted}`}
                    </VisuallyHiddenStyle>
                    <span aria-hidden={true}>{content.subHeading}</span>
                    {accessibilities.length > 0 && ' • '}
                    {accessibilities.map((accessibility, i) => (
                        <Accessibility accessibility={accessibility} key={`${content.id}-${i}`}>
                            <AccessibilityText>{''}</AccessibilityText>
                        </Accessibility>
                    ))}
                </ContentSubheader>
                <ContentDescription type={TYPES.LARGE} expanded={expanded} isUpcoming={isUpcoming}>
                    {content.description}
                    {!isUpcoming && (
                        <Link
                            href={{
                                pathname: content.item.urls.svtplay,
                                query: {
                                    info: 'visa',
                                },
                            }}
                            passHref
                        >
                            <AssociatedMoreInfoLink data-rt="associated-more-info-link">
                                Mer om programmet
                            </AssociatedMoreInfoLink>
                        </Link>
                    )}
                </ContentDescription>
            </Information>
            <ExpandButton
                expanded={expanded}
                isUpcoming={isUpcoming}
                onClick={() => setExpanded(!expanded)}
                aria-label={`Visa beskrivning för ${content.heading}`}
            />

            <MobileDescription expanded={expanded} type={TYPES.LARGE}>
                {content.description}
                {!isUpcoming && (
                    <Link
                        href={{
                            pathname: content.item.urls.svtplay,
                            query: {
                                info: 'visa',
                            },
                        }}
                        passHref
                    >
                        <AssociatedMoreInfoLink>Mer om programmet</AssociatedMoreInfoLink>
                    </Link>
                )}
            </MobileDescription>
        </Content>
    );
};

export default AssociatedContentItem;
